import { createContext, useReducer, useState } from "react";
import { ADMIN_SCREENS } from "../admin/lib/constants";
import { MODELS } from "../admin/lib/models";

export const AdminContext = createContext({});

const Provider = AdminContext.Provider;

const modelsReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      return {
        ...state,
        [action.model]: action.data
      };
    case 'add':
      return {
        ...state,
        [action.model]: [...state[action.model], action.data]
      };
    case 'update':
      return {
        ...state,
        [action.model]: state[action.model].map(item => {
          if (item.id === action.data.id) {
            return action.data;
          }
          return item;
        })
      };
    case 'updateMany':
      return {
        ...state,
        [action.model]: state[action.model].map(item => {
          const found = action.data.find(el => el.id === item.id);
          if (found) {
            return found;
          }
          return item;
        })
      };
    case 'delete':
      return {
        ...state,
        [action.model]: state[action.model].filter(item => item.id !== action.id)
      };
    default:
      return state;
  }
      
};

export const AdminProvider = ({children}) => {
  const [adminScreen, setAdminScreen] = useState(ADMIN_SCREENS.TABLE);
  const [model, setModel] = useState(MODELS.PIECE);
  const [modelsData, dispatchModelsData] = useReducer(modelsReducer, {
    [MODELS.ISSUE]: [],
    [MODELS.BLOCK]: [],
    [MODELS.PIECE]: [],
    [MODELS.AUTHOR]: [],
    [MODELS.USER]: [],
    [MODELS.BOOK]: [],
    [MODELS.ABOUT]: [],
  });

  return (
    <Provider value={{
      adminScreen,
      setAdminScreen,
      model,
      setModel,
      modelsData,
      dispatchModelsData
    }}>
      {children}
    </Provider>
  )
};